import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';
import { DialogActions } from '@material-ui/core';

export const ExportButton = styled.button`
    min-width: fit-content;
    ursor: pointer;
    color: rgb(255, 255, 255);
    border: none;
    font-weight: 700;
    padding: 8px 16px;
    text-align: center;
    border-radius: 5px;
    white-space: nowrap;
    vertical-align: middle;
    background-color: rgb(242, 101, 34);
    text-transform: uppercase;
    font-family: "DM Sans", sans-serif;
    :hover{
      background-color: rgb(220, 75, 34);
    }
`;

export const SecaoBotoes = styled.section`
  padding: 0 0 1px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 8px;

  & > * {
    flex: 1;
  }
`;

export const SecaoPagina = styled.section`
  ul,
  li {
    margin: 0;
    padding: 0;
  }

  li {
    list-style-type: none;
  }
`;

const AutoComplete = styled(Autocomplete)`
  & .MuiInputBase-input {
    height: 1.5rem;
  }
`;

export const LoadingDiv = styled.div`
  width: 99vw;
  height: 93vh;
  display: flex;        
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: #ffffffaf;
  z-index: 9999;

  p {
    position: absolute;
    top: 40%;
  }
`;

export const DialogStyledActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between !Important;
  padding-left: 10px;
  padding-right: 10px;
`;